import { useForm } from 'react-hook-form'
import {
    Select,
    FormErrorMessage, FormLabel, FormControl, Input,
    Button, Flex, useDisclosure, Box, useColorModeValue, Spacer,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton,
} from '@chakra-ui/react'
import React, {useState} from "react";
import {useAuthHeader} from "react-auth-kit";
import axios from "axios";
import {useNavigate} from "react-router-dom";

export default function PartnerCreate() {
    const textColor = useColorModeValue("gray.200", "white");
    const token = useAuthHeader();
    const [partnerResponse, setPartnerResponse] = useState('')
    const [showError, setShowError] = useState(null)
    const navigate = useNavigate();
    const {
        handleSubmit,
        register,
        setValue,
        formState: { errors, isSubmitting },
    } = useForm()
    const { isOpen, onOpen, onClose } = useDisclosure()

    const toggle = () => {
        onClose()
        navigate(`/admin_area/partners`);
    }

    const toggleShow = () => {
        setShowError(true)
    }

    async function onSubmit(values) {
        try {
            const newData = await createPartner(values, token());
            setPartnerResponse(newData)
            onOpen()
        } catch (e) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    alert(JSON.stringify(e.response.data, null, 2))
                    resolve()
                }, 1000)
            })
        }
    }

    return (
        <Flex direction='column' pt={{ base: "150px", md: "75px" }}>

            <Box w='100%' mb='20px'>
                <Flex maxW='500px'>
                    <Button colorScheme='teal' type='submit' onClick={() => {navigate(`/admin_area/partners`)}}>
                        Назад
                    </Button>
                    <Spacer/>
                    <Button colorScheme='teal' type='submit' onClick={() => {
                        setValue('login', "test_login")
                        setValue('pass', 'test_password')
                        setValue('name', "test_name")
                    }}>
                        Выбрать шаблон
                    </Button>
                </Flex>
            </Box>

            <Box
                border='1px'
                borderRadius='5px'
                borderColor={textColor}
                maxW='500px'
                w='100%'
                p={4}
            >

                <form onSubmit={handleSubmit(onSubmit)}>
                    <FormControl isInvalid={errors.login}>
                        <FormLabel mt={"10px"} htmlFor='limit'>Логин</FormLabel>
                        <Input
                            id='login'
                            {...register('login', {
                                required: 'Поле не должно быть пустым',
                            })}
                        />
                        <FormErrorMessage>
                            {errors.login && errors.login.message}
                        </FormErrorMessage>
                    </FormControl>

                    <FormControl isInvalid={errors.pass}>
                        <FormLabel mt={"10px"} htmlFor='pass'>Пароль</FormLabel>
                        <Input
                            id='pass'
                            {...register('pass', {
                                required: 'Поле не должно быть пустым',
                            })}
                        />
                        <FormErrorMessage>
                            {errors.pass && errors.pass.message}
                        </FormErrorMessage>
                    </FormControl>

                    <FormControl isInvalid={errors.name}>
                        <FormLabel mt={"10px"} htmlFor='name'>Имя</FormLabel>
                        <Input
                            id='name'
                            {...register('name', {
                                required: 'Поле не должно быть пустым',
                            })}
                        />
                        <FormErrorMessage>
                            {errors.name && errors.name.message}
                        </FormErrorMessage>
                    </FormControl>

                    <Button mt={4} colorScheme='teal' isLoading={isSubmitting} type='submit'>
                        Создать нового партнера
                    </Button>
                </form>

            </Box>
            <Modal isOpen={isOpen} size={'xl'} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Создание партнера</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {partnerResponse.token
                            ? "Партнер создан успешно"
                            : <pre style={{fontSize: '15px'}}>{JSON.stringify(partnerResponse, null, 2)}</pre>
                        }
                        <br/>
                        <br/>
                        {partnerResponse.info
                            ? partnerResponse.info
                            : <pre style={{fontSize: '15px'}}>{JSON.stringify(partnerResponse, null, 2)}</pre>
                        }
                        <br/>
                        <br/>
                        {showError
                            ? <pre-wrap>{JSON.stringify(partnerResponse.error, null, 2)}</pre-wrap>
                            : ''
                        }
                    </ModalBody>
                    <ModalFooter>
                        {partnerResponse.error
                            ? <Button colorScheme='red' onClick={toggleShow}>Подробности</Button>
                            : ''
                        }
                        <Spacer/>
                        <Button colorScheme='blue' onClick={toggle}>Закрыть</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </Flex>
    )
}


async function createPartner(params, token) {
    try {
        let raw = {
            login: params.login,
            pass: params.pass,
            name: params.name,
        };

        const response = await axios.post(`/api/v1/profile`, raw,
            {headers: {Authorization: token}})
        return await response.data
    } catch (e) {
        if (e.response) {
            let error = {}
            error['info'] = "Невозможно создать партнера"
            if ( Object.assign(e.response.data).errors ) {
                error['error'] = Object.assign(e.response.data).errors
            } else {
                error['error'] = e.response.data
            }

            return error
        }
    }
}
